// s101 (D497, Dr. Rami 2026-10-13): the patient's primary care doctor, kept in profile.insurance.pcp.
// "On app sign up / the insurance section of the profile - if HMO can select PCP. Usually this is on the
// insurance card so it could be obtained and matched to our database, or the patient selects PCP."
// Pure (no imports): the gate check-pcp-profile runs it.

/** The record stored as insurance.pcp, from a directory row (or the card when nothing matched). */
export function pcpFromDirectoryRow(r, source) {
  if (!r) return null
  const a = r.address || {}
  return {
    npi: r.npi || null, name: r.name || '', credential: r.credential || null, specialty: r.specialty || null,
    address: [a.line1, a.city, [a.state, a.zip].filter(Boolean).join(' ')].filter(Boolean).join(', ') || null,
    phone: r.phone || null, fax: r.fax || null, onOrella: !!r.onOrella, doctorId: r.doctorId || null,
    source: source === 'card' ? 'card' : 'picked',
  }
}
export function pcpFromCardOnly(card) {
  if (!card || !card.name) return null
  return { npi: null, name: card.name, address: card.address || null, phone: card.phone || null, fax: null,
    onOrella: false, doctorId: null, source: 'card' }
}

/** The card's PCP block from a scan (the API's pcpName/pcpPhone/pcpAddress/pcpId), or null. */
export function cardPcpFromScan(extracted) {
  const n = extracted && String(extracted.pcpName || '').trim()
  if (!n) return null
  return { name: n, phone: extracted.pcpPhone || null, address: extracted.pcpAddress || null, id: extracted.pcpId || null }
}

/** What to search the directory for: the card name without "Dr." / "MD" / punctuation. */
export function pcpSearchText(name) {
  return String(name || '').replace(/\b(dr|md|do|np|pa|facp|mph)\b\.?/gi, ' ').replace(/[^a-zA-Z' -]/g, ' ').replace(/\s+/g, ' ').trim()
}

/** Does a directory row plausibly match the card's PCP? Same last name, and the first name or initial. */
export function rowMatchesCardPcp(row, cardName) {
  const words = pcpSearchText(cardName).toLowerCase().split(' ').filter(Boolean)
  const rn = pcpSearchText(row && row.name).toLowerCase().split(' ').filter(Boolean)
  if (words.length < 2 || rn.length < 2) return false
  const cardLast = words[words.length - 1], cardFirst = words[0]
  return rn.includes(cardLast) && (rn.includes(cardFirst) || rn.some((w) => w[0] === cardFirst[0]))
}

/** Is a PCP called for? Shown for every plan; marked as needed for HMO-style plans. */
export const pcpNeededFor = (coverageType) => /hmo|medi-?cal|medicaid|managed/i.test(String(coverageType || ''))

/**
 * s110 (b77, mockup P2): what the PCP finder asks for. An NPI of 10 digits is searched alone; a partial NPI is
 * said to be wrong; otherwise a name of 2+ letters within the place. `key` changes only when the question does.
 */
export function pcpQuery({ q = '', npi = '', place = '' } = {}) {
  const n = String(npi || '').replace(/[^0-9]/g, '')
  const name = String(q || '').replace(/\s+/g, ' ').trim()
  const pl = String(place || '').replace(/\s+/g, ' ').trim()
  if (n.length === 10) return { ready: true, npi: n, q: '', place: '', npiInvalid: false, key: `npi:${n}` }
  const npiInvalid = n.length > 0
  const ready = !npiInvalid && name.replace(/ /g, '').length >= 2
  return { ready, npi: '', q: name, place: pl, npiInvalid, key: ready ? `q:${name.toLowerCase()}|${pl.toLowerCase()}` : 'none' }
}
